export const ADMIN = 'admin';
export const DISTRIBUTOR = 'distributor';
export const SELLER = 'seller';
